import TYPES from '../types'

const initState = {
  companyLists: null,
}

const CompanyState = (state = initState, action) => {
  const { type, data } = action
  switch (type) {
    case TYPES.LOGOUT:
      return { ...initState }
    case TYPES.ALT_COMPANY_LISTS:
      return {
        ...state,
        companyLists: data,
      }
    default:
      return state
  }
}

export default CompanyState
